var GlobalData = {
    ServeUrl(){
        // return window.location.origin+"/out-api";
        return 'https://admin.w.zxhphp.com';
    },
    isMobile() {
    	 let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    	 return flag;
    },
    ChangeExcel(file){
       // Excel文件的MIME类型
          var excelTypes = [
              'application/vnd.ms-excel',  // .xls
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',  // .xlsx
              'application/vnd.ms-excel.sheet.macroEnabled.12',  // .xlsm
              'application/vnd.ms-excel.template.macroEnabled.12',  // .xltm
              'application/vnd.ms-excel.addin.macroEnabled.12',  // .xlam
              'application/vnd.ms-excel.sheet.binary.macroEnabled.12', // .xlsb
              'text/csv',
          ];
          // 也可以根据文件扩展名判断（双重保险）
          var fileName = file.name.toLowerCase();
          var isExcelFile = excelTypes.includes(file.type) || 
                           fileName.endsWith('.xls') || 
                           fileName.endsWith('.xlsx') ||
                           fileName.endsWith('.xlsm') ||
                           fileName.endsWith('.xlsb') ||
                           fileName.endsWith('.csv');;
          
          if (!isExcelFile) {
              return true;
          }
    },
    ResetData(obj) {
        if (!obj || typeof obj !== 'object') return obj;
        for (let key in obj) {
            if (obj.hasOwnProperty(key)) {
                const value = obj[key];
                switch (typeof value) {
                    case 'string':
                        obj[key] = '';
                        break;
                    case 'number':
                        obj[key] = 0;
                        break;
                    case 'boolean':
                        obj[key] = false;
                        break;
                    case 'object':
                        if (Array.isArray(value)) {
                            obj[key] = [];
                        } else if (value !== null) {
                            GlobalData.ResetData(value);
                        } else {
                            obj[key] = null;
                        }
                        break;
                    default:
                        obj[key] = null;
                }
            }
        }
        return obj;
    },
    localData(k, v) {
        if (k === undefined) return false;
        if (v === undefined) {
            return localStorage.getItem(k);
        } else if (v === null) {
            localStorage.removeItem(k);
        } else {
            localStorage.setItem(k, v);
        }
    },
    /** 时间戳转换 */
    timestampFormat(timestamp, thisTime) {
        // let curTimestamp = parseInt(new Date().getTime() / 1000), //当前时间戳
        let curTimestamp = thisTime, //当前时间戳
            timestampDiff = curTimestamp - timestamp, // 参数时间戳与当前时间戳相差秒数
            curDate = new Date(curTimestamp * 1000), // 当前时间日期对象
            tmDate = new Date(timestamp * 1000), // 参数时间戳转换成的日期对象
            Y = tmDate.getFullYear(),
            m = tmDate.getMonth() + 1,
            d = tmDate.getDate(),
            H = tmDate.getHours(),
            i = tmDate.getMinutes(),
            s = tmDate.getSeconds();
        if (timestampDiff < 60) { // 一分钟以内
            return "刚刚";
        } else if (timestampDiff < 3600) { // 一小时前之内
            return Math.floor(timestampDiff / 60) + "分钟前";
        } else if (curDate.getFullYear() == Y && curDate.getMonth() + 1 == m && curDate.getDate() == d) {
            return '今天 ' + ((String(H).length == 1 ? '0' : '') + H) + ':' + ((String(i).length == 1 ? '0' : '') +
            i);
        } else {
            var newDate = new Date((curTimestamp - 86400) * 1000); // 参数中的时间戳加一天转换成的日期对象
            if (newDate.getFullYear() == Y && newDate.getMonth() + 1 == m && newDate.getDate() == d) {
                return '昨天 ' + ((String(H).length == 1 ? '0' : '') + H) + ':' + ((String(i).length == 1 ? '0' :
                    '') +
                    i);
            } else if (curDate.getFullYear() == Y) {
                return ((String(m).length == 1 ? '0' : '') + m) + '月' + ((String(d).length == 1 ? '0' : '') + d) +
                    '日 ' + ((String(H).length == 1 ? '0' : '') + H) + ':' + ((String(i).length == 1 ? '0' : '') +
                    i);
            } else {
                return Y + '年' + ((String(m).length == 1 ? '0' : '') + m) + '月' + ((String(d).length == 1 ? '0' :
                        '') +
                    d) + '日 ' + ((String(H).length == 1 ? '0' : '') + H) + ':' + ((String(i).length == 1 ? '0' :
                    '') + i);
            }
        }
    },
}

export default GlobalData;